var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google 1",
    clipPath: "url(#clip0_256_6124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1696 9.08734L12.196 9.08691C11.7997 9.08691 11.4785 9.40806 11.4785 9.80432V12.671C11.4785 13.0672 11.7997 13.3884 12.1959 13.3884H17.2493C16.696 14.8244 15.6632 16.0271 14.3455 16.7913L16.5002 20.5213C19.9567 18.5223 22.0002 15.0148 22.0002 11.0884C22.0002 10.5293 21.959 10.1297 21.8766 9.67967C21.814 9.33777 21.5171 9.08734 21.1696 9.08734Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.0002 17.6954C8.52714 17.6954 6.36822 16.3442 5.2087 14.3447L1.47876 16.4946C3.3769 19.7844 6.93274 21.9997 11.0002 21.9997C12.9955 21.9997 14.8783 21.4625 16.5002 20.5263V20.5211L14.3454 16.791C13.3598 17.3627 12.2192 17.6954 11.0002 17.6954Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5 20.5262V20.5211L14.3452 16.791C13.3596 17.3626 12.2192 17.6954 11 17.6954V21.9997C12.9953 21.9997 14.8782 21.4625 16.5 20.5262Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.30435 10.9998C4.30435 9.78079 4.63702 8.64036 5.20854 7.65478L1.4786 5.50488C0.537195 7.12167 0 8.99932 0 10.9998C0 13.0002 0.537195 14.8779 1.4786 16.4947L5.20854 14.3448C4.63702 13.3592 4.30435 12.2188 4.30435 10.9998Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.0002 4.30435C12.6128 4.30435 14.0941 4.87738 15.2511 5.83056C15.5366 6.06568 15.9515 6.04871 16.2129 5.78725L18.244 3.75611C18.5407 3.45946 18.5196 2.97387 18.2027 2.69895C16.2641 1.0172 13.7419 0 11.0002 0C6.93274 0 3.3769 2.21534 1.47876 5.50511L5.2087 7.65501C6.36822 5.65555 8.52714 4.30435 11.0002 4.30435Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.251 5.83056C15.5364 6.06568 15.9513 6.04871 16.2128 5.78725L18.2439 3.75611C18.5405 3.45946 18.5194 2.97387 18.2025 2.69895C16.264 1.01716 13.7417 0 11 0V4.30435C12.6126 4.30435 14.094 4.87738 15.251 5.83056Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_256_6124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.548d246e7931d7a5a39f567397b1d9ab.svg";
export { ForwardRef as ReactComponent };